/* eslint-disable no-shadow */
import { Dict } from 'mixpanel-browser';

export enum MixpanelEventName {
    login = 'Log In',
    register = 'Register',
    addDocument = 'Add Document',
    editDocument = 'Edit Document',
    deleteDocument = 'Delete Document',
    dvlaLookup = 'DVLA Lookup',
    addDvlaDoc = 'Add DVLA Document',
    addReminder = 'Reminders - Added',
    completedReminder = 'Reminders - Completed',
    deleteReminder = 'Reminders - Deleted',
    remindLaterReminder = 'Reminders - Remind Later',
    timelineViewed = 'Reminders - Timeline Viewed',
    purchaseAppPackage = 'Purchased App Package',
    // Smart Scan Events
    smartScanStarted = 'Smart Scan - Started',
    smartScanCompleted = 'Smart Scan - Completed',
    smartScanFailed = 'Smart Scan - Failed',
    // Password-protected files (fileLock.ts)
    lockedFileDetected = 'Locked File - Detected',
    lockedFileUnlocked = 'Locked File - Unlocked',
    lockedFileSkipped = 'Locked File - Skipped',
    // AI Consent Events
    aiConsentGranted = 'AI Consent - Granted',
    aiConsentDenied = 'AI Consent - Denied',
    // Custom Categories Events
    customCategoryCreated = 'Custom Category - Created',
    customCategoryUsed = 'Custom Category - Used',
    // Data Fields Events
    dataFieldAdded = 'Data Field - Added',
    dataFieldCopied = 'Data Field - Copied',
    // Notes Events
    noteAdded = 'Note - Added',
    // Document Preview Events
    documentPreviewed = 'Document - Previewed',
    // Vehicle Events
    vehicleDocumentAdded = 'Vehicle Document - Added',
    manualVehicleAdded = 'Manual Vehicle - Added',
    vehicleEdited = 'Vehicle - Edited',
    vehicleDeleted = 'Vehicle - Deleted',
    vehicleViewed = 'Vehicle - Viewed',
    // Property Events
    propertyAdded = 'Property - Added',
    propertyEdited = 'Property - Edited',
    propertyDeleted = 'Property - Deleted',
    propertyViewed = 'Property - Viewed',
    propertyDocumentAdded = 'Property Document - Added',
    // Sharing - Connection Events
    connectionRequestSent = 'Connection - Request Sent',
    connectionRequestAccepted = 'Connection - Request Accepted',
    connectionRequestRejected = 'Connection - Request Rejected',
    connectionRequestCancelled = 'Connection - Request Cancelled',
    connectionRemoved = 'Connection - Removed',
    // Sharing - Document Sharing Events
    documentShared = 'Document - Shared',
    documentShareEdited = 'Document Share - Edited',
    documentShareRemoved = 'Document Share - Removed',
    shareAllEnabled = 'Share All - Enabled',
    shareSomeEnabled = 'Share Some - Enabled',
    shareNoneEnabled = 'Share None - Enabled',
    sharedDocumentViewed = 'Shared Document - Viewed',
    // Sharing - Public Link Events
    publicLinkCreated = 'Public Link - Created',
    publicLinkCopied = 'Public Link - Copied',
    publicLinkRevoked = 'Public Link - Revoked',
    publicLinkViewsChecked = 'Public Link - Views Checked',
    mySharedLinksViewed = 'My Shared Links - Viewed',
    // Onboarding Events
    onboardingStarted = 'Onboarding - Started',
    onboardingAddItemViewed = 'Onboarding - Add Item Viewed',
    onboardingFileUploaded = 'Onboarding - File Uploaded',
    onboardingUploadSkipped = 'Onboarding - Upload Skipped',
    onboardingScanRevealShown = 'Onboarding - Scan Reveal Shown',
    onboardingNameEntered = 'Onboarding - Name Entered',
    onboardingNameSkipped = 'Onboarding - Name Skipped',
    onboardingSuggestionSelected = 'Onboarding - Suggestion Selected',
    onboardingCategorySelected = 'Onboarding - Category Selected',
    onboardingCategorySkipped = 'Onboarding - Category Skipped',
    onboardingReminderSet = 'Onboarding - Reminder Set',
    onboardingReminderSkipped = 'Onboarding - Reminder Skipped',
    onboardingDocumentCreated = 'Onboarding - Document Created',
    onboardingSharingViewed = 'Onboarding - Sharing Viewed',
    onboardingFeaturesViewed = 'Onboarding - Features Viewed',
    onboardingCompleted = 'Onboarding - Completed',
    onboardingProfileSelected = 'Onboarding - Profile Selected',
    onboardingAreasSelected = 'Onboarding - Areas Selected',
    onboardingCostProofViewed = 'Onboarding - Cost Proof Viewed',
    onboardingPersonalisedHelpViewed = 'Onboarding - Personalised Help Viewed',
    onboardingThreeStepsViewed = 'Onboarding - Three Steps Viewed',
    onboardingPrivacyViewed = 'Onboarding - Privacy Viewed',
    onboardingSocialProofViewed = 'Onboarding - Social Proof Viewed',
    onboardingDocDetailViewed = 'Onboarding - Doc Detail Viewed',
    onboardingDocDetailEdited = 'Onboarding - Doc Detail Edited',
    onboardingSampleDemoStarted = 'Onboarding - Sample Demo Started',
    onboardingSampleDemoCompleted = 'Onboarding - Sample Demo Completed',
    onboardingSampleDemoEscaped = 'Onboarding - Sample Demo Escaped',
    onboardingStoryViewed = 'Onboarding - Story Viewed',
    onboardingStoriesCompleted = 'Onboarding - Stories Completed',
    onboardingStoriesSkipped = 'Onboarding - Stories Skipped',
    onboardingYourTurnViewed = 'Onboarding - Your Turn Viewed',
    onboardingYourTurnChosen = 'Onboarding - Your Turn Chosen',
    // App Shortcuts Events
    shortcutLaunched = 'Shortcut - Launched',
    // Guest Flow Events
    guestSessionCreated = 'Guest - Session Created',
    guestPaywallViewed = 'Guest - Paywall Viewed',
    guestPurchaseCompleted = 'Guest - Purchase Completed',
    guestRegistrationStarted = 'Guest - Registration Started',
    guestIdentityMerged = 'Guest - Identity Merged',
    // Shepherd (dashboard tour) Events
    shepherdStarted = 'shepherd_started',
    shepherdStepViewed = 'shepherd_step_viewed',
    shepherdSkipped = 'shepherd_skipped',
    shepherdCompleted = 'shepherd_completed',
    shepherdReplayed = 'shepherd_replayed',

    // App-wide sweep 2026-08-04 (869edcw81). Additive only - nothing above
    // this line may change, dashboards depend on those exact names.
    documentViewed = 'Document - Viewed',
    documentDownloaded = 'Document - Downloaded',
    offlineSaved = 'Offline - Saved',
    offlineRemoved = 'Offline - Removed',
    offlineOpened = 'Offline - Opened',
    bulkDeleteUsed = 'Bulk - Delete Used',
    bulkMoveUsed = 'Bulk - Move Used',
    calendarEventAdded = 'Calendar - Event Added',
    searchPerformed = 'Search - Performed',
    searchResultOpened = 'Search - Result Opened',
    documentPinned = 'Document - Pinned',
    documentUnpinned = 'Document - Unpinned',
    settingToggled = 'Setting - Toggled',
    pushDeviceRegistered = 'Push - Device Registered',
    previewUnavailableShown = 'Preview - Unavailable Type Shown',
    scanPaperUsed = 'Scan Paper - Used',

    // Full-app audit 2026-08-04 (869edd47m). Additive only, same rule as above.
    // Auth + session
    loginFailed = 'Log In - Failed',
    registrationFailed = 'Register - Failed',
    mfaFailed = 'MFA - Failed',
    verifyFailed = 'Verify - Failed',
    passwordResetRequested = 'Password Reset - Requested',
    passwordResetCompleted = 'Password Reset - Completed',
    passwordResetFailed = 'Password Reset - Failed',
    sessionExpired = 'Session - Expired',
    loggedOut = 'Logged Out',
    deepLinkOpened = 'Deep Link - Opened',
    // Paywall + subscription funnel
    paywallViewed = 'Paywall - Viewed',
    purchaseStarted = 'Purchase - Started',
    purchaseFailed = 'Purchase - Failed',
    purchaseCancelled = 'Purchase - Cancelled',
    purchaseRestored = 'Purchase - Restored',
    purchaseRestoreFailed = 'Purchase - Restore Failed',
    subscriptionCancelled = 'Subscription - Cancelled',
    subscriptionSwitchedToAnnual = 'Subscription - Switched To Annual',
    upgradePromptShown = 'Upgrade Prompt - Shown',
    // These two were already live as raw strings in customerCenter.ts; the
    // values here must stay exactly as first shipped.
    customerCenterOpened = 'Customer Center Opened',
    customerCenterDismissed = 'Customer Center Dismissed',
    // Upload + documents
    uploadStarted = 'Upload - Started',
    uploadFileAttached = 'Upload - File Attached',
    uploadFileFailed = 'Upload - File Failed',
    uploadStepSkipped = 'Upload - Step Skipped',
    uploadDiscarded = 'Upload - Discarded',
    addDocumentFailed = 'Add Document - Failed',
    editDocumentFailed = 'Edit Document - Failed',
    dvlaLookupFailed = 'DVLA Lookup - Failed',
    documentDownloadFailed = 'Document - Download Failed',
    offlineSaveFailed = 'Offline - Save Failed',
    // Birthdays hub (2026-08-05). Props are counts/booleans only - never
    // names or dates of birth.
    birthdaysScreenViewed = 'Birthdays - Screen Viewed',
    birthdayAddStarted = 'Birthdays - Add Started',
    birthdayAdded = 'Birthdays - Added',
    birthdayEdited = 'Birthdays - Edited',
    // Offered when a family member has a date of birth but no birthday yet.
    // The accept/decline split is the whole point of measuring it: it tells us
    // whether the prompt is welcome or nagging.
    birthdayPromptAccepted = 'Birthdays - Prompt Accepted',
    birthdayPromptDeclined = 'Birthdays - Prompt Declined',
    // Everything else
    dashboardCategoryOpened = 'Dashboard - Category Opened',
    accountDeleted = 'Account - Deleted',
    pushNotificationOpened = 'Push - Opened',
    // Notification permission primer (features/NotificationPrimer)
    notificationPrimerViewed = 'Notification Primer - Viewed',
    notificationPrimerAllowed = 'Notification Primer - Allowed',
    notificationPrimerDeclined = 'Notification Primer - Declined',
    // Learn (how-to videos)
    learnViewed = 'Learn - Viewed',
    learnCtaTapped = 'Learn - CTA Tapped',
    learnIndexViewed = 'Learn - Index Viewed',
    // Lifecycle offers (/offer/:slug)
    offerViewed = 'Offer - Viewed',
    offerConfirmed = 'Offer - Confirmed',
    offerPurchased = 'Offer - Purchased',
    offerDismissed = 'Offer - Dismissed',
    // Dashboard lifecycle cards (features/dashboard/lifecycle)
    dashboardCardViewed = 'Dashboard Card - Viewed',
    dashboardCardTapped = 'Dashboard Card - Tapped',
    dashboardCardDismissed = 'Dashboard Card - Dismissed',
    // First document screen before the dashboard (features/FirstDocument)
    firstDocumentViewed = 'First Document - Viewed',
    firstDocumentChosen = 'First Document - Chosen',
    firstDocumentSkipped = 'First Document - Skipped',
    // Store rating ask (features/RatingPrompt)
    ratingPrompted = 'Rating - Prompted',
    ratingStoreOpened = 'Rating - Store Opened',
    ratingDeclined = 'Rating - Declined',
    // Suggested dates on a document with no date (common/components/DocDetail)
    reminderSuggested = 'Reminder - Suggested',
    reminderSuggestionTaken = 'Reminder - Suggestion Taken',
    // "Two more to go" dashboard card (features/dashboard/lifecycle)
    activationNudgeShown = 'Activation - Nudge Shown',
}
export type UserEventProps = {
    mixpanelProps: Dict,
    id: string | number,
    eventName: MixpanelEventName,
}
export type CustomEventProps = {
    mixpanelProps: Dict,
    id: string | number,
    eventName: MixpanelEventName,
}
